import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";
import { Button } from "@/components/ui/button";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_aqua-automation-6/artifacts/xhc56h1e_fe56aded-38ef-4918-806c-2e1721a85900.jpeg";

const links = [
  { id: "home", label: "Home", href: "#home", tid: NAV.linkHome },
  { id: "products", label: "Products", href: "#products", tid: NAV.linkProducts },
  { id: "how", label: "How It Works", href: "#how", tid: NAV.linkHow },
  { id: "services", label: "Services", href: "#services", tid: NAV.linkServices },
  { id: "industries", label: "Industries", href: "#industries", tid: NAV.linkIndustries },
  { id: "about", label: "About", href: "#about", tid: NAV.linkAbout },
  { id: "contact", label: "Contact", href: "#contact", tid: NAV.linkContact },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-zinc-200">
      <div className="px-6 md:px-12 lg:px-24 flex items-center justify-between h-20">
        <a href="#home" className="flex items-center gap-2" data-testid={NAV.logo}>
          <img
            src={LOGO_URL}
            alt="Aquamatic — Smart Wireless Water Management Automation"
            className="h-14 md:h-16 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={l.tid}
              className="font-mono uppercase text-[11px] tracking-[0.2em] text-zinc-700 hover:text-[#002FA7] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a href="#contact">
            <Button
              data-testid={NAV.ctaQuote}
              className="bg-[#002FA7] hover:bg-[#00227A] text-white rounded-none font-mono uppercase tracking-wider text-xs px-6 h-11"
            >
              Get a Quote
            </Button>
          </a>
        </div>

        <button
          className="lg:hidden text-zinc-900"
          onClick={() => setOpen(!open)}
          data-testid={NAV.mobileToggle}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-zinc-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-mono uppercase text-xs tracking-[0.2em] text-zinc-700"
              >
                {l.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)}>
              <Button
                className="bg-[#002FA7] hover:bg-[#00227A] text-white rounded-none w-full font-mono uppercase tracking-wider text-xs h-11"
              >
                Get a Quote
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
